<template>
  <common-dashboard-card-template
    :isDataFound="shareLibDocs && shareLibDocs.length"
    @viewMore="$emit('viewMore')"
  >
    <template #header>
      <div class="flex-row flex__left">
        <span class="margin-right-15 font-size__large">
          <i class="fas fa-folder fa-2x color__white"></i>
        </span>
        <h3 class="tt1 color__white">{{ cardTitle }}</h3>
      </div>
    </template>

    <template #body>
      <div v-if="shareLibDocs && shareLibDocs.length">
        <template v-for="item in shareLibDocs">
          <div
            :key="item.Id"
            class="file-item flex-row flex-left margin-bottom-10 clickable has-border__bottom"
            @click="downloadFile(item)"
          >
            <i
              class="far fa-file color__link font-size__small margin-bottom-10 margin-right-10"
            ></i>
            <span class="file-name padding-bottom-10"
              >{{ item.title }} - {{ item.attachmentName }}</span
            >
          </div>
        </template>
      </div>
    </template>
  </common-dashboard-card-template>
</template>
<script>
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import constants from "../../constants";
import downloadService from "../../services/downloadService";
import CommonDashboardCardTemplate from "../common/layout/common-dashboard-card-template";
import DocDashboardCardItem from "./doc-dashboard-card-item";

export default {
  mixins: [vbAttachmentTokenMixin],
  name: "share-library-dashboard-card-v2",
  props: ["cardTitle", "shareLibDocs"],
  components: {
    DocDashboardCardItem,
    CommonDashboardCardTemplate,
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
  },
  data() {
    return {
      perfectScrollbarSetting: { maxScrollbarLength: 350 },
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      DOWNLOAD_FILE_URL: constants.DOWNLOAD_FILE_URL
    };
  },
  methods: {
    downloadFile(shareLibrary) {
      downloadService.downloadShareLibrary(shareLibrary.attachmentId);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/share-library-dashboard-card-v2.vue